// extracted by mini-css-extract-plugin
module.exports = {"message":"Unsubscribe_SA_message__6tT2b","title":"Unsubscribe_SA_title__2PmaJ","parrafo":"Unsubscribe_SA_parrafo__107SQ","size":"Unsubscribe_SA_size__1ZgKR"};